import React, { useEffect } from 'react'

const Blog = () => {
    useEffect(()=>{
        window.location.href = 'https://www.prolegion.com/blog/'
    },[])
  return null;
}

export default Blog